import { useMutation, useQueryClient } from '@gogame/query';

import { updateCustomMetric } from '../../sources/metrics';
import { metrics, updateCustomMetric as queryKey } from '../queryKeyFactory';
import { customMetricsPredicate } from './utils/customMetricsPredicate';

export const useUpdateMetric = () => {
  const queryClient = useQueryClient();

  const updateMutation = useMutation(queryKey(), updateCustomMetric, {
    successMessage: () => 'Custom metric updated',
    refreshOptions: {
      queryKey: metrics.all(),
    },
    onSuccess: ({ name }) => {
      queryClient.resetQueries({
        predicate: (query) => customMetricsPredicate(query, name),
      });
    },
  });

  return [updateMutation.mutateAsync, updateMutation];
};
